import { AfterViewInit, Inject, ElementRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
//import { OwlOptions } from 'ngx-owl-carousel-o';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
//import { SessionModel } from '../interface/session-model';
//import { URL } from '../interface/url-enum';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MsalService } from '@azure/msal-angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';
import {EncryptDecryptService} from 'src/app/services/encrypt-decrypt.service';



declare var $: any;
declare var jquery: any;
@Component({
  selector: 'app-ssologin',
  templateUrl: './ssologin.component.html',
  styleUrls: ['./ssologin.component.css']
})
export class SSOLoginComponent implements OnInit {
  loading: any;
  //session
  PageName: any;
  //SessionList: SessionModel = new SessionModel();
  userId: string;
  username: string;
  sessionId: string;
  token: string;
  lastlogintime: string;
  firstname: string;
  employeeid: string;
  usertype: string;
  chatBot: boolean;
  customername: string;
  accessHome: boolean;
  ssoLaunch: boolean;
  onLoad: boolean = false;
  customerid: any;
  Userdetail: any;
  userAcceptancePrivacyPolicyContent: string = ''
  modalReference: any;

  @ViewChild('userAcceptancePrivacyPolicyModal') userAcceptancePrivacyPolicyModal: ElementRef;

  constructor(private router: Router, public sanitizer: DomSanitizer, public activatedRoute: ActivatedRoute
    , public commonService: CommonService, private dataService: DataService, private authService: AuthService, @Inject(MAT_DATE_FORMATS) private dateFormats, private msalservice: MsalService, private route: ActivatedRoute, private dialog: MatDialog, private modalService: NgbModal,private memorystore: MemoryStorageService,private encryptservice:EncryptDecryptService
  ) { }

  ngOnInit(): void {
    // alert("sso");
    if (this.dataService.is_sso == true) {
      this.queryParams();
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  isValidLogin: boolean = false;
  isValidating: boolean = true;

  public queryParams() {

    this.loading = true;
    var valid = false;
    this.activatedRoute.queryParams.subscribe(params => {
      let data = params;
      if (data["guid"] == undefined) {
        if (this.dataService.is_sso == true) {
          let url = this.dataService.sso_url;
          window.location.href = url;
        } else {
          this.isValidLogin = false;
          this.isValidating = false;
          this.commonService.setLoading(false);
          this.commonService.isSessionExpired = true;
          this.router.navigateByUrl('/login');
        }
      }
      else {
        valid = true;
        let datum = {
          // "contextname": data["contextName"],
          "guid": data["guid"],
          "userId": this.encryptservice.decryptUsingAES256(data["userId"]),
          "userName": this.encryptservice.decryptUsingAES256(data["userName"]),
          "timestamp": data["ts"],
          "action": data["action"],
          "token": data["token"]
          //"luappuid": data["luappuid"]
        }
        //this.Userdetail.push(datum);
        this.Userdetail = datum;
        if (valid) {
          // // sessionStorage.setItem('context', '');
          // sessionStorage.setItem('guid', this.Userdetail.guid);
          // sessionStorage.setItem('userId', this.Userdetail.userId);
          // sessionStorage.setItem('userName', this.Userdetail.userName);
          // sessionStorage.setItem('timestamp', this.Userdetail.timestamp);
          // sessionStorage.setItem('action', this.Userdetail.action);
          // sessionStorage.setItem('token', this.Userdetail.token);
          // //  sessionStorage.setItem('luappuid', this.Userdetail.luappuid);
          this.memorystore.setItem('guid', this.Userdetail.guid);
          this.memorystore.setItem('Userdetail', this.Userdetail.userId);
          this.memorystore.setItem('userName', this.Userdetail.userName);
          this.memorystore.setItem('timestamp', this.Userdetail.timestamp);
          this.memorystore.setItem('action', this.Userdetail.action);
          this.memorystore.setItem('token', this.Userdetail.token);
          if ( this.memorystore.getItem('token') != undefined) {
            if ( this.memorystore.getItem('Userdetail') != undefined) {
              // this.commonService.setUserInfoToLocalStorage('token', this.Userdetail.token);
              this.memorystore.setItem('token', this.Userdetail.token);
              this.getlogeduserdetails(this.Userdetail);
            }
            else {
              if (this.dataService.is_sso == true) {
                let url = this.dataService.sso_url;
                window.location.href = url;
              } else {
                this.isValidLogin = false;
                this.isValidating = false;
                this.commonService.setLoading(false);
                this.commonService.isSessionExpired = true;
                this.router.navigateByUrl('/login');
              }

              //var destinationURL = "/" + this.Userdetail[0]["destinationURL"];
              // this.router.navigateByUrl('/ExecuteRecon');
              //this.router.navigateByUrl(destinationURL);
            }
          } else {
            if (this.dataService.is_sso == true) {
              let url = this.dataService.sso_url;
              window.location.href = url;
            } else {
              this.isValidLogin = false;
              this.isValidating = false;
              this.commonService.setLoading(false);
              this.commonService.isSessionExpired = true;
              this.router.navigateByUrl('/login');
            }
          }
        }
      }
    });

    //if (!valid) {
    //  this.isValidLogin = false;
    //  this.isValidating = false;
    //  this.commonService.setLoading(false);
    //}
  }

  public getlogeduserdetails(userDetails) {

    //var user = sessionStorage.getItem("utp");
    var user = {
      userId: userDetails.userId,
      userName: userDetails.userName,
      ts: userDetails.timestamp,
      action: userDetails.action,
      contextName: userDetails.contextname,
      guid: userDetails.guid,
      token: userDetails.token
    }
    //setTimeout(() => {
    this.get_user_session_data(userDetails.userId);
    //this.router.navigateByUrl('/home');
    // }, 100);
    this.isValidLogin = true;
    // this.dataService.ssologinValidate().subscribe(data => {
    //   if (data != undefined && data != "" && data != null && data.status.toUpperCase() == "SUCCESS") {
    //     //setTimeout(() => {
    //     this.get_user_session_data(userDetails.userId);
    //     //this.router.navigateByUrl('/home');
    //     // }, 100);
    //     this.isValidLogin = true;
    //   }
    //   else {
    //     this.isValidLogin = false;
    //     this.commonService.isSessionExpired = true;
    //     if (this.dataService.is_sso == true) {
    //       this.router.navigate(['/error']);
    //       // let url = this.dataService.sso_url;
    //       // window.location.href = url;
    //     }
    //     else {
    //       this.router.navigate(['/login']);
    //     }
    //     // this.router.navigateByUrl('/logout');
    //     // window.location.href = environment.loginurl;
    //     // this.router.navigate(['/errorPage']);
    //   }
    //   // this.isValidating = false;
    //   // this.commonService.setLoading(false);
    // })

    // this.IAMServiceService.getuserdetails(user).subscribe(
    //  userData => {
    //    //if (userData["status"] != undefined) {
    //    //  if (userData["status"] != null) {
    //    //    if (userData["statuscode"] == 4000) {
    //    //      this.router.navigateByUrl('authenticate/logout');

    //    //      return;
    //    //    }
    //    //  }
    //    //}
    //    //if (userData["statusCode"] != undefined) {
    //    //  if (userData["statusCode"] == 100000) {
    //    //    if (userData["responseData"] != undefined) {
    //    //      sessionStorage.setItem("userType", userData["responseData"]["type"]);
    //    //      sessionStorage.setItem("firstName", userData["responseData"]["first_name"]);
    //    //      sessionStorage.setItem("userName", userData["responseData"]["first_name"]);
    //    //      sessionStorage.setItem("tenentid", userData["responseData"]["primaryTenantId"])
    //    //      sessionStorage.setItem("Tntname", userData["responseData"]["primaryTenantName"])
    //    //      //sessionStorage.setItem("userid", userData["responseData"]["employee_id"]);
    //    //      sessionStorage.setItem("emp_id", userData["responseData"]["employee_id"]);
    //    //      //Added For demo purpose. Email id needs to be passed from IAM service//
    //    //      if (userData["responseData"]["emailId"] != undefined && userData["responseData"]["emailId"].toString().trim() != "") {
    //    //        sessionStorage.setItem("email", userData["responseData"]["emailId"]);

    //    //      }

    //    //      else {

    //    //        sessionStorage.setItem("email", userData["responseData"]["employee_id"] + "@Weatherford.com");

    //    //      }
    //    //      //end//
    //    //      sessionStorage.setItem("userid", userData["responseData"]["user_id"]);
    //    //      if (this.PageName == "" || this.PageName == undefined) {
    //    //        this.router.navigateByUrl('valuebuilder/landingpage');
    //    //      }
    //    //      else if (this.PageName == "Report") {

    //    //        this.router.navigateByUrl('/Report');

    //    //      }
    //    //      else if (this.PageName == "Execution") {

    //    //        this.router.navigateByUrl('/ExecuteRecon');

    //    //      }
    //    //      else if (this.PageName == "FileUpload") {

    //    //        this.router.navigateByUrl('/ReconFileUpload');

    //    //      }
    //    //      return;

    //    //    }
    //    //  }
    //    //  else if (userData["statuscode"] == 2000) {
    //    //    this.router.navigateByUrl('authenticate/sessionexpired')

    //    //  }
    //    //}
    //  },
    //  error => { throw error }

    // )
  }

  get_user_session_data(userName: string) {
    this.authService.getPWMUser(userName).subscribe(user => {
      if (user != null && user.status && user.data.length > 0) {

        // this.commonService.setUserInfoToLocalStorage('userId', user.data[0].user_id);
        // this.commonService.setUserInfoToLocalStorage('userEmail', user.data[0].user_email);
        // this.commonService.setUserInfoToLocalStorage('userName', user.data[0].display_name);
        // this.commonService.setUserInfoToLocalStorage('groupName', user.data[0].group_name);
        // this.commonService.setUserInfoToLocalStorage('groupLogo', user.data[0].group_logo);
        // this.commonService.setUserInfoToLocalStorage('projectId', user.data[0].project_id);
        // this.commonService.setUserInfoToLocalStorage('projectName', user.data[0].project_name);
        // this.commonService.setUserInfoToLocalStorage('subgroupId', user.data[0].subgroup_id == null ? 0 : user.data[0].subgroup_id);
        // this.commonService.setUserInfoToLocalStorage('subgroupName', user.data[0].subgroup_name == null ? '' : user.data[0].subgroup_name);
        // this.commonService.setUserInfoToLocalStorage('roleId', user.data[0].role_id);
        // this.commonService.setUserInfoToLocalStorage('roleName', user.data[0].role_name);
        // this.commonService.setUserInfoToLocalStorage('isManagerialRole', user.data[0].is_managerial_role);
        // this.commonService.setUserInfoToLocalStorage('dateFormat', user.data[0].report_date_format);
        // this.commonService.setUserInfoToLocalStorage('lastLoginAt', new Date());
        // this.commonService.setUserInfoToLocalStorage('language', 'English');
        // this.commonService.setUserInfoToLocalStorage('dashboard_filters', user.data[0].dashboard_filters);
        // this.commonService.setUserInfoToLocalStorage('is_initiator', user.data[0].is_initiator);
        // this.commonService.setUserInfoToLocalStorage('is_implementation', user.data[0].is_implementation);
        this.memorystore.setItem('userId', user.data[0].user_id);
        this.memorystore.setItem('userEmail', user.data[0].user_email);
        this.memorystore.setItem('userName', user.data[0].display_name);
        this.memorystore.setItem('groupName', user.data[0].group_name);
        this.memorystore.setItem('groupLogo', user.data[0].group_logo);
        this.memorystore.setItem('projectId', user.data[0].project_id);
        this.memorystore.setItem('projectName', user.data[0].project_name);
        this.memorystore.setItem('subgroupId', user.data[0].subgroup_id == null ? 0 : user.data[0].subgroup_id);
        this.memorystore.setItem('subgroupName', user.data[0].subgroup_name == null ? '' : user.data[0].subgroup_name);
        this.memorystore.setItem('roleId', user.data[0].role_id);
        this.memorystore.setItem('roleName', user.data[0].role_name);
        this.memorystore.setItem('isManagerialRole', user.data[0].is_managerial_role);
        this.memorystore.setItem('dateFormat', user.data[0].report_date_format);
        this.memorystore.setItem('lastLoginAt', new Date());
        this.memorystore.setItem('language', 'English');
        this.memorystore.setItem('dashboard_filters', user.data[0].dashboard_filters);
        this.memorystore.setItem('is_initiator', user.data[0].is_initiator);
        this.memorystore.setItem('is_implementation', user.data[0].is_implementation);
        if (user.data[0].hasOwnProperty('logonlogoffdetailsid')) {
          // this.commonService.setUserInfoToLocalStorage('logonLogoffDetailsId', user.data[0].logonlogoffdetailsid);
          this.memorystore.setItem('logonLogoffDetailsId', user.data[0].logonlogoffdetailsid);
        }
        //added by dharshana on 03.11.25 for token validation.
        if (user.data[0].user_id != null && user.data[0].hasOwnProperty('logonlogoffdetailsid') && user.data[0].authtoken != null) {          
          this.memorystore.setItem('authtoken', user.data[0].authtoken);
        }
        //added by dharshana on 03.11.25 for token validation.
        // this.commonService.setUserInfoToLocalStorage('isOpenAdvanceSearch', user.data[0].is_open_advance_search);
        // this.commonService.setUserInfoToLocalStorage('isOpenHistory', user.data[0].is_open_history);
        this.memorystore.setItem('isOpenAdvanceSearch', user.data[0].is_open_advance_search);
        this.memorystore.setItem('isOpenHistory', user.data[0].is_open_history);
        if (user.data[0].is_accept_privacy_policy == 1) {
          if (user.data[0].issessionexist == "True") {
            // this.commonService.setUserInfoToLocalStorage('logonLogoffDetailsId', '');
            this.memorystore.setItem('logonLogoffDetailsId', '');
            this.memorystore.setItem('authtoken', '');
            const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {
              disableClose: true,
              data: {
                title: "Login",
                messageBoxType: 'question',
                icon: '',
                message: 'Your last session is seems to be open. <br> Do you want to close that session and continue?'
              }
            });
            dialogRef1.afterClosed().subscribe((confirmed: boolean) => {
              if (confirmed) {
                this.authService.killUserSession(user.data[0].logonlogoffdetailsid).subscribe(res => {
                  if (res != null && res.status == true) {
                    // this.commonService.setUserInfoToLocalStorage('logonLogoffDetailsId', res.data);
                    this.memorystore.setItem('logonLogoffDetailsId', res.data);
                    this.memorystore.setItem('authtoken', res.dumpdata);
                    // if(config.is_Addprocess_In_Create_Work_page==false|| config.is_Addprocess_In_Create_Work_page==undefined){
                    if (user.data[0].project_name != "PI IDEAS") {
                      // if (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0) {
                        if (this.memorystore.getItem('isManagerialRole') == 0) { 
                      // window.location.href='/control-panel';
                        this.router.navigate(['/control-panel']);
                      }
                      else {
                        // window.location.href='/work-item';
                        this.router.navigate(['/work-item']);
                      }
                    }
                    else {
                      //this.router.navigate(['/ibos360-dashboard-infographical']);
                      this.router.navigate(['/home']);
                    }
                    EmmiterService.get("userInfo").emit();
                  }
                  else {
                    if (res != null)
                      this.commonService.showMessageBox(res.error_message, "Login", "error");
                    else
                      this.commonService.showMessageBox("Internal error please connect PI support.", "Login", "error");

                    // this.router.navigate(['/login']);
                    if (this.dataService.is_sso == true) {
                      //this.router.navigate(['/sso-logout']);
                      let url = this.dataService.sso_url;
                      window.location.href = url;
                    }
                    else {
                      this.router.navigate(['/login']);
                    }
                  }
                });
              }
              else {
                let url = this.dataService.sso_url;
                window.location.href = url;
              }
            });
          }
          else {
            // if(user.data[0].project_name !="Al Maya - PI IDEAS"){//Commented by Ramesh R as on 11032024
            //     if (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0)
            //       this.router.navigate(['/home']);
            //     else
            //       this.router.navigate(['/work-item']);
            // }
            // else{                          
            //     this.router.navigate(['/ibos360-dashboard-infographical']);
            // }
            // if (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0) {
              if (this.memorystore.getItem('isManagerialRole') == 0) {
              this.router.navigate(['/home']);
            }
            else {
              this.router.navigate(['/work-item']);
            }
            EmmiterService.get("userInfo").emit();
          }
        } else {
          const dialogRef5 = this.dialog.open(ConfirmationDialogComponent, {
            disableClose: false,
            data: {
              title: "Privacy Policy",
              messageBoxType: 'ok',
              icon: '',
              buttonText: {
                ok: 'Accept',
                cancel: 'No'
              },
              message: user.data[0].data_privacy_content
            }

          });
          dialogRef5.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
              this.acceptPrivacyPolicy();
            } else {
              let url = this.dataService.sso_url;
              window.location.href = url;
            }
          })
          // this.userAcceptancePrivacyPolicyContent = user.data[0].data_privacy_content;
          // this.showModal(this.userAcceptancePrivacyPolicyModal, 'xl');
        }

        this.dateFormats.display.dateInput = this.commonService.DateFormat.toUpperCase();
      }
      else {
        if (this.dataService.is_sso == true) {
          //this.router.navigate(['/sso-logout']);
          //this.commonService.showMessageBox("You are not authorized to access the application. <br>Please contact Cognix support team.", "Warning!");
          // this.router.navigate(['/errorPage'], { queryParams: { issso: 'true' } });
          if (!user.status || user.data.length == 0) {
            const dialogRef3 = this.dialog.open(ConfirmationDialogComponent, {
              disableClose: true,
              data: {
                title: "Warning!",
                messageBoxType: 'ok',
                icon: '',
                message: 'You are not authorized to access the application. <br>Please contact Cognix support team.'
              }
            });
            dialogRef3.afterClosed().subscribe((confirmed: boolean) => {
              if (confirmed) {
                let url = this.dataService.sso_url;
                window.location.href = url;
              }
            })
          }
          // else {
          // this.router.navigate(['/error']);
          // }
        }
        else {
          this.router.navigate(['/login']);
        }
        // if (this.dataService.is_sso == true) {
        //   this.router.navigate(['sso-logout'], { queryParams: { issso: 'true' } });
        // }
        // else {
        //   this.commonService.showMessageBox("You are not authorized to access the application. <br>Please contact Cognix support team.", "Warning!");
        //   //this.commonService.showMessageBox("Authentication failed.Check Your Credentials. <br>Please contact Cognix support team.", "Warning!");
        //   // this.commonService.showMessageBox("Authentication failed.Please Check Your Credentials", "Warning!");
        // }
      }
    });
  }
  showModal(modelTemplate, modalSize: string = 'lg') {

    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  acceptPrivacyPolicy() {
    // this.authService.acceptPrivacyPolicy(Number(this.commonService.getUserInfoFromLocalStorage('userId'))).subscribe(res => {
      this.authService.acceptPrivacyPolicy(Number(this.memorystore.getItem('userId'))).subscribe(res => {
      if (res.status) {
        // this.modalReference.close();
        // if (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0) {
          if (this.memorystore.getItem('isManagerialRole') == 0) {
          this.router.navigate(['/home']);
        }
        else {
          this.router.navigate(['/work-item']);
        }
        EmmiterService.get("userInfo").emit();
      }
    });
  }
}

